/* eslint-disable import/no-import-module-exports */
/* global document, window */
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import AppContainer from 'react-hot-loader/lib/AppContainer';
// react-router-dom is present in peerDep `fe-co-demo`
// eslint-disable-next-line import/no-extraneous-dependencies
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { APP_PAGE, APP_PROPS, APP_ROOT } from './constants';

const page = window[APP_PAGE];
const props = window[APP_PROPS] || {};
const supportsHistory = 'pushState' in window.history;

const render = (NewApp) =>
  hydrateRoot(
    document.getElementById(APP_ROOT),
    <AppContainer>
      <BrowserRouter forceRefresh={!supportsHistory}>
        <NewApp page={page} {...props} />
      </BrowserRouter>
    </AppContainer>,
  );

if (module.hot) {
  module.hot.accept('./App', () => {
    // eslint-disable-next-line global-require
    const NewApp = require('./App').default;
    render(NewApp);
  });
}

render(App);
